import request from '@/utils/request'

export function fetchManageUserList(current, size, searchParams) {
  return request({
    url: 'manage/user/list',
    method: 'post',
    data: {
      ...searchParams,
      current,
      size
    }
  })
}

export function fetchUserInfo(userId) {
  return request({
    url: 'manage/user/info/' + userId,
    method: 'get'
  })
}

export function fetchInstitutionTree(userId) {
  return request({
    url: 'manage/institution/tree',
    method: 'get',
    params: {
      userId: userId
    }
  })
}

export function postAgentInfo(params) {
  return request({
    url: 'manage/user/createOrUpdate',
    method: 'post',
    data: params
  })
}

export function updateUserDyAccountId(params) {
  return request({
    url: 'manage/dyuser/updateUser',
    method: 'post',
    data: params
  })
}

export function fetchManageQueue(page, size, queueType, searchParams) {
  return request({
    url: 'manage/queue/list',
    method: 'post',
    data: {
      page: page,
      size: size,
      type: queueType,
      ...searchParams
    }
  })
}

// 批量分案-2、委外分案-3、留案-4、取消留案-5 列表查询
export function fetchManageBatchTasks(page, size, userId, divisionType, searchParams) {
  return request({
    url: 'taskReport/getManualDivisionTaskslist',
    method: 'post',
    data: {
      page,
      size,
      userId,
      divisionType,
      ...searchParams
    }
  })
}

// 获取可分配名单
export function exportoutsourcedDistributable(userId) {
  return request({
    url: 'exportoutsourcedDistributable',
    method: 'get',
    params: {
      userId
    }
  })
}

// 人工分案导入
export function importManualDivisionTasks(operator, file) {
  return request({
    url: 'task/importManualDivisionTasks',
    method: 'post',
    data: {
      operator,
      file
    }
  })
}

// 催记管理列表
export function fetchCollectionLogsList(currentPage, pageSize, userId, searchParams) {
  return request({
    url: 'task/collectionLogs',
    method: 'post',
    data: {
      currentPage,
      pageSize,
      userId,
      ...searchParams
    }
  })
}

// 导出催记管理列表
export function exportCollectionLog(userId, params) {
  return request({
    url: 'exportCollectionLog',
    method: 'get',
    params: {
      userId,
      ...params
    }
  })
}

// 全部案件
export function allTask(data) {
  return request({
    url: 'task/listing',
    method: 'post',
    data
  })
}

export function fetchQueueInfo(queueId) {
  return request({
    url: 'manage/queue/info/' + queueId,
    method: 'get'
  })
}

export function fetchQueueAgents(queueId) {
  return request({
    url: 'manage/queue/agents/' + queueId,
    method: 'get'
  })
}

export function getAutoQueue(page, size) {
  return request({
    url: 'task/getAutoQueue',
    method: 'get',
    params: {
      size,
      page
    }
  })
}

export function fetchQueueTasks(queueId, page, size, searchParams) {
  return request({
    url: 'manage/queue/tasks',
    method: 'post',
    data: {
      page,
      size,
      ...searchParams,
      workQueueId: queueId
    }
  })
}

// 导出
export function exportWorkQueueManageList(queueId, searchParams) {
  return request({
    url: 'exportWorkQueueManageList',
    method: 'get',
    params: {
      ...searchParams,
      workQueueId: queueId
    }
  })
}

export function bindQueueAgent(taskIds, agentId, name, id, workQueueId) {
  return request({
    url: 'manage/task/bindAgent',
    method: 'post',
    data: {
      taskIds,
      agentId,
      creator: name,
      creatorId: id,
      workQueueId
    }
  })
}

export function unbindQueueAgent(taskIds) {
  return request({
    url: 'manage/task/bindAgent',
    method: 'post',
    data: {
      taskIds: taskIds
    }
  })
}

export const updatedLink = 'manage/user/upload/'

// 队列
export function getWorkQueueList(params) {
  return request({
    url: 'task/getWorkQueueList',
    method: 'get',
    params
  })
}

// 字典
// dictType 字典类型 必填（fd_business_type-业务类型，profuct-产品, task_status-案件状态, report_task_status-下载中心状态）
export function getDictionaryList(dictType) {
  return request({
    url: 'task/getDictionaryList',
    method: 'get',
    params: {
      dictType
    }
  })
}

// 字典
// dictType 字典类型 必填（9109-教育程度，9108-婚姻状况）
export function getAfdDictionaryList(dictType) {
  return request({
    url: 'task/getAfdDictionaryList',
    method: 'get',
    params: {
      dictType
    }
  })
}

export function getUser(username, roleId) {
  return request({
    url: 'manage/getUser',
    method: 'get',
    params: {
      username,
      roleId
    }
  })
}
